import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { ReferencedProductType } from '~/Api/HrPriceReferencing/MaxPrice';
import { ReferenceBasketVersion } from '~/Api/PriceReferencing';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { Module, selectReferenceBasketVersions, State as PriceReferencingState } from '~/PriceReferencing';
import { State as SiMaxPriceState, Update } from '~/SiMaxPrice/reducer';
import { Status, Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

interface State {
	priceReferencing: PriceReferencingState;
	siMaxPrice: SiMaxPriceState;
}

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Statuses.saving;
		case 'updated':
			return Statuses.saved;
		case 'failed':
			return Statuses.failed;
		default:
			return null;
	}
});

function mapStateToProps(
	{ siMaxPrice, priceReferencing }: State,
	{ group }: OwnProps
): {
	updateStatus: Status | null;
	versions: ReferenceBasketVersion[] | null;
	productTypes: ReferencedProductType[] | null;
} {
	return {
		updateStatus: selectUpdateStatus(group.id, siMaxPrice.update),
		versions: selectReferenceBasketVersions(priceReferencing, Module.siMaxPrice),
		productTypes: siMaxPrice.productTypes?.types ?? null,
	};
}

export default connect(mapStateToProps)(ParametersPanel);
